import React, { createContext, useContext, useReducer } from 'react'
import reducer, { defaultInitialState } from './FullTextReducer'

export const FullTextStateContext = createContext(null)
export const FullTextDispatchContext = createContext(null)

export default function FullTextContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, defaultInitialState)

  return (
    <FullTextStateContext.Provider value={state}>
      <FullTextDispatchContext.Provider value={dispatch}>{children}</FullTextDispatchContext.Provider>
    </FullTextStateContext.Provider>
  )
}

export const useFullTextStateContext = () => {
  const context = useContext(FullTextStateContext)
  if (!context) {
    throw new Error(
      'useFullTextStateContext must be used within a FullTextContextProvider. If writing a test, use <StateProvider> from testUtils.js'
    )
  }
  return context
}
export const useFullTextDispatchContext = () => {
  const context = useContext(FullTextDispatchContext)
  if (!context) {
    throw new Error(
      'useFullTextDispatchContext must be used within a FullTextContextProvider. If writing a test, use <StateProvider> from testUtils.js'
    )
  }
  return context
}
